import {useEffect, useState} from "react";
import {useApp} from "../Contex";
import {fetchProfile} from "../api/api";
import {Link} from "react-router-dom";

export default function AccountPage() {
    const {refresh} = useApp()
    const [user, setUser] = useState({});

    const fetchData = () => {
        fetchProfile().then(res => {
            if (res.ok) {
                console.log(res)
                setUser(res.profile)
            }
        })
    }

    useEffect(() => {
        fetchData()
    }, [refresh]);

    return <div className="card rounded rounded-4 shadow-sm">
            <Link
                className="btn btn-outline-secondary rounded rounded-3 position-absolute"
                style={{top: "5px", right: "5px"}}
                to={`settings`}
            >
                <i className="bi bi-gear"/>
            </Link>
            <div className=" py-4 px-4">
                <h3 className="text-center mb-3">{user.email}</h3>

                <p className="fw-bold mb-2 text-uppercase text-secondary text-center">Roller per enhet</p>

                <div className="list-group">
                    {user?.locations &&
                        Object.entries(user.locations).map(([sid, {name, role}]) => (
                            <div key={sid} className="list-group-item d-flex justify-content-between align-items-start">
                                <div>
                                    <div className="fw-semibold">{name}</div>
                                    <small className="text-muted">ID: {sid}</small>
                                </div>
                                <span className={`badge rounded-pill ${role?.name === "admin" ? "bg-success" : "bg-dark-subtle"}`}>{role?.name}</span>
                            </div>
                        ))}
                </div>
            </div>
    </div>

}
